import React from 'react';
import { motion } from 'framer-motion';
import { GiftIcon } from 'lucide-react';
import { SectionHeading } from './ui/SectionHeading';
import { bonuses } from '../data/bonuses';
import { bonusTotalValue, bonusValue, totalBonuses } from '../data/offer';
export function BonusSection() {
  return <section className="border-y border-slate-600/30 bg-blue-950 py-16 sm:py-20" aria-labelledby="bonus-title" data-id="element-18" data-mp="1ydi6yabp1vla">
      <div className="mx-auto max-w-4xl px-4" data-id="element-19" data-mp="1annwu0irel4q">
        <SectionHeading id="bonus-title" data-id="element-20" data-mp="1amcs9yhhp9ck">The {totalBonuses} <span className="text-amber-400" data-id="element-21" data-mp="15q5ks19g3psi">Exclusive Bonuses</span></SectionHeading>

        <ul className="mt-10 overflow-hidden rounded-2xl border border-slate-600/60 bg-slate-950 shadow-lg shadow-black/30" data-id="element-22" data-mp="1jhamra0acu60">
          {bonuses.map((bonus, index) => {
          const Icon = bonus.icon;
          return <motion.li key={bonus.title} initial={{
            opacity: 0,
            y: 12
          }} whileInView={{
            opacity: 1,
            y: 0
          }} viewport={{
            once: true
          }} transition={{
            duration: 0.28,
            delay: index * 0.04,
            ease: [0.23, 1, 0.32, 1]
          }} className="flex gap-4 border-b border-slate-600/20 p-5 last:border-b-0 sm:p-6" data-id="element-23" data-mp="qzojqj0q31w5" data-mpi={index}>
                <span className="flex h-10 w-10 shrink-0 items-center justify-center rounded-lg border border-yellow-400/50 bg-blue-950 text-yellow-400" data-id="element-24" data-mp="2jiehbw5otiwu">
                  <Icon className="h-5 w-5" aria-hidden="true" data-id="element-25" data-mp="1qtqqll2661bw" />
                </span>
                <div className="flex-1" data-id="element-26" data-mp="1vs217y0agfv6">
                  <p className="text-xs font-bold uppercase tracking-[.14em] text-amber-400" data-id="element-27" data-mp="1vt3co3l7v4df">Bonus {bonus.number}</p>
                  <h3 className="mt-1 text-lg font-extrabold uppercase leading-tight text-stone-50" data-id="element-28" data-mp="20q3j4flza952">{bonus.title}</h3>
                  <p className="mt-1.5 text-sm leading-relaxed text-slate-300" data-id="element-29" data-mp="25o51szfhs6g0">{bonus.description}</p>
                </div>
                <p className="shrink-0 text-right" data-id="element-30" data-mp="3h5elnn2j90hu">
                  <span className="block text-xs font-semibold text-slate-400 line-through decoration-amber-400 decoration-2" data-id="element-31" data-mp="3h43jtssne2td">{bonusValue}</span>
                  <span className="mt-0.5 block text-sm font-extrabold uppercase tracking-wide text-amber-400" data-id="element-32" data-mp="1c4kiul2odgkh">Free</span>
                </p>
              </motion.li>;
        })}
        </ul>

        <div className="mt-6 flex flex-col items-center justify-between gap-5 rounded-2xl border-2 border-amber-400 bg-slate-950 px-6 py-6 text-center shadow-lg shadow-black/40 sm:flex-row sm:text-left" data-id="element-33" data-mp="1m2i738kjbdd3">
          <div data-id="element-34" data-mp="tdt04swssdtf">
            <p className="text-xs font-bold uppercase tracking-[.16em] text-slate-300" data-id="element-35" data-mp="teck0f60dca3">Value of all {totalBonuses} bonuses</p>
            <p className="mt-1 text-3xl font-bold tracking-tight text-slate-300 line-through decoration-amber-400 decoration-2" data-id="element-36" data-mp="1760vcg8fnwq0">
              {bonusTotalValue}
            </p>
          </div>
          <div className="sm:text-right" data-id="element-37" data-mp="envb6ar1nk36">
            <p className="text-xs font-bold uppercase tracking-[.16em] text-slate-300" data-id="element-38" data-mp="emk687lv46ah">Your price today</p>
            <p className="mt-1 inline-flex items-center gap-2 text-4xl font-bold tracking-tight text-amber-400" data-id="element-39" data-mp="alid88ijgqgy">
              <GiftIcon className="h-7 w-7" aria-hidden="true" data-id="element-40" data-mp="59uvvl9xplgs" /> FREE
            </p>
          </div>
        </div>
      </div>
    </section>;
}